import packageJson from '../../package.json'

const version = packageJson.version

export const APP_NAME = 'TruthEngineHub'
export const APP_ID = 7

// Version comes from package.json; MAJOR (e.g. 1.7) is not currently checked in the refresh guard.
export const MAJOR_VERSION = version.split('.').slice(0, 2).join('.')
export const PATCH_VERSION = version.slice(MAJOR_VERSION.length)

export const DEFAULT_API_CACHE_TIMEOUT_MS = 1000 * 60 * 15 // 15 minutes

export const AVERAGING_DECIMAL_PLACES_ROUNDING = 2

export const MAX_DASHBOARD_NAME_LEN = 35

export const WEEK_START = 1 // monday
export const DAY_JS_CONFIG = {
  name: 'en-au',
  weekStart: WEEK_START,
}

/// B2C / MSAL ///
export const B2C_AUTHORITY_DOMAIN = 'truthengine.b2clogin.com'
